import React from 'react';

import { Link } from 'expo-router';
import { StyleSheet, View } from 'react-native';

import { Typography } from 'components/ui';
import { t } from 'state/intl/translations';
import { primitive, spacing } from 'styles/constants';
import { routes } from 'utils/routing';

export const DeliveryTerms = () => {
  return (
    <View style={styles.container}>
      <Typography style={styles.termsText}>
        {t('deliveryTermsPrefix')}
        <Link href={routes.deliveryTerms}>
          <Typography style={styles.termsLink}>{t('clickHereForDetails')}</Typography>
        </Link>
      </Typography>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    alignItems: 'center',
    justifyContent: 'center',
    paddingHorizontal: spacing.$4,
  },
  termsLink: {
    color: primitive.$black,
    textDecorationLine: 'underline',
  },
  termsText: {
    lineHeight: 20,
    textAlign: 'center',
  },
});
